var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#F4B731"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21831 4.5H8.90381C11.1454 4.5 12.8447 5.69025 13.4769 7.42163H14.625V8.46844H13.7188C13.7362 8.63381 13.7453 8.80256 13.7453 8.97356V8.99944C13.7453 9.19181 13.734 9.38194 13.7115 9.56756H14.625V10.6138H13.455C12.8064 12.3216 11.1206 13.5 8.90438 13.5H5.21831V10.6138H3.9375V9.56756H5.21831V8.46844H3.9375V7.42219H5.21831V4.5ZM6.24825 10.6138V12.5612H8.90325C10.5424 12.5612 11.7596 11.781 12.3261 10.6138H6.24825ZM12.6416 9.56756H6.24825V8.46844H12.6439C12.6669 8.64113 12.6793 8.81831 12.6793 8.99944V9.02475C12.6793 9.20981 12.6664 9.39037 12.6416 9.567V9.56756ZM8.90438 5.43656C10.5503 5.43656 11.7714 6.23756 12.3345 7.42106H6.24825V5.43713H8.90325L8.90438 5.43656Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDai);
export default __webpack_public_path__ + "static/media/dai.4cd2ce9c7984debbe5d2283747d12355.svg";
export { ForwardRef as ReactComponent };